import { render } from "./StatusDropdown.vue?vue&type=template&id=0866648e&scoped=true"
import script from "./StatusDropdown.vue?vue&type=script&lang=js"
export * from "./StatusDropdown.vue?vue&type=script&lang=js"

import "./StatusDropdown.vue?vue&type=style&index=0&id=0866648e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0866648e"]])

export default __exports__